import React, { useCallback, useContext } from 'react';
import { ContainerComum } from '../styles';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { useDashboard } from '~/pages/Dashboard/hooks/useDashboard';
import { Link } from 'react-router-dom';
import { FilterContext } from '~/context/filter';
import { toast } from 'react-toastify';
import { nanoid } from 'nanoid';

type EstoqueStatus = 'Sem estoque' | 'Com estoque' | 'Estoque baixo';

const COLORS: Record<EstoqueStatus, string> = {
  'Sem estoque': '#FF6361',
  'Com estoque': '#0088FE',
  'Estoque baixo': '#FF8042',
};

export const BodyProdutos: React.FC = () => {
  const { dashboardData } = useDashboard();
  const { AddFilterOrUpdate, RemoveFilter, filtersContexto } =
    useContext(FilterContext);

  const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const arrProduto = dashboardData?.produtos || [];

  const data = arrProduto.flatMap((produto) => [
    { name: 'Sem estoque', value: Number(produto.qtd_sem_estoque) },
    { name: 'Com estoque', value: Number(produto.qtd_com_estoque) },
    { name: 'Estoque baixo', value: Number(produto.qtd_baixo_estoque) },
  ]);

  const codTela = 28;

  const createFilter = useCallback(
    (
      itens: Array<{
        codCampo: number;
        codTipoDados: number;
        codTipoInfo: number | null;
        condicao: number;
        desNome: string;
        desValor: number;
        nomeBd: string;
        listagemInfo: string | null;
        tipoExpressao: number;
      }>,
    ) => ({
      codTela,
      edit: false,
      flg_pesquisado: false,
      name_card: '',
      cor: '',
      itens: itens.map((item) => ({
        cod_campo: item.codCampo,
        cod_tipo_dados: item.codTipoDados,
        cod_tipo_info: item.codTipoInfo,
        condicao: item.condicao,
        des_nome: item.desNome,
        des_valor: item.desValor,
        expressao_validacao: null,
        index: nanoid(),
        isBlock: false,
        listagem_info: item.listagemInfo,
        nome_bd: item.nomeBd,
        tipo_expressao: item.tipoExpressao,
      })),
    }),
    [codTela],
  );

  const onClick = useCallback(async () => {
    await delay(200);

    const tab = document.getElementById(`${codTela}-tab`);
    if (!tab) return;

    const labelTela = 'Cadastro de Produto';
    const element = Array.from(document.querySelectorAll('h3')).find(
      (el) => el.textContent?.trim() === labelTela,
    );

    if (element) {
      toast.warning('Finalize esta ação para prosseguir');
      return;
    }

    const divPane = document.getElementById(`${codTela}`);
    if (!divPane) return;

    document.body.style.pointerEvents = 'none';

    const filtersToRemove = [14087];
    const existingFilter = filtersContexto.find(
      (filter) => filter.codTela === codTela,
    );

    if (existingFilter) {
      existingFilter.itens
        .filter((filter) => filtersToRemove.includes(filter.cod_campo))
        .forEach((f) => RemoveFilter(codTela, f.index));
    }

    await delay(200);

    const filtros = [];

    const listagemInfo = `[
            {
              "cod_item": 1,
              "valor": "0.000,000",
              "des_item": "QUANTIDADE"
            }
          ]`;

    filtros.push(
      createFilter([
        {
          codCampo: 14087,
          codTipoDados: 4,
          codTipoInfo: 116,
          condicao: 2,
          desNome: 'Qtd. Estoque Lj',
          desValor: 10,
          nomeBd: 't.qtd_estoque',
          listagemInfo,
          tipoExpressao: 1,
        },
      ]),
    );

    filtros.forEach(AddFilterOrUpdate);

    const buttonPesquisar = divPane.querySelector<HTMLButtonElement>(
      '[data-testid="botao-pesquisar"]',
    );

    if (buttonPesquisar) {
      await delay(500);
      buttonPesquisar.click();
    }

    await delay(200);
    document.body.style.pointerEvents = 'auto';
  }, [AddFilterOrUpdate, RemoveFilter, createFilter, filtersContexto]);

  return (
    <ContainerComum gap="0rem">
      <ResponsiveContainer width="100%" height={235}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={70}
            fill="#8884d8"
            label
          >
            {data.map((entry: any) => (
              <Cell
                key={`cell-${entry.name}`}
                fill={COLORS[entry.name as EstoqueStatus]}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
      <div className="qtd-card-produtos">
        <Link to="/mix-de-produto">
          <span>{arrProduto[0]?.qtd_total || 0} Ativos</span>
        </Link>
        <Link
          to="/produto"
          onClick={async () => {
            await onClick();
          }}
        >
          <span>{arrProduto[0]?.qtd_baixo_estoque || 0} Estq. Baixo</span>
        </Link>
      </div>
    </ContainerComum>
  );
};
